import React, { useState } from 'react';

import AddDomainPresentational from './add-domain-presentational';

const layout = {
	labelCol: { span: 6 },
	wrapperCol: { span: 18 },
};
const tailLayout = {
	wrapperCol: { offset: 6, span: 18 },
};
const AddDomainFunctional = ({ domains, addDomain, removeDomain, editDomain, domainListLoading }) => {
	const [modalVisible, setmodalVisible] = useState(false);
	const [activeDomain, setactiveDomain] = useState(null);
	const onFinish = ({ domain }) => {
		addDomain(domain);
		setmodalVisible(false);
	};
	const onEditFinish = ({ domain }) => {
		editDomain({
			key: activeDomain.key,
			domainName: domain,
		});
		setmodalVisible(false);
		setactiveDomain(null);
	};

	const handleModalVisible = (modalVisible) => {
		setmodalVisible(modalVisible);
		if (!modalVisible) {
			setactiveDomain(null);
		}
	};

	const handleEditDomain = (domain) => {
		setactiveDomain(domain);
		setmodalVisible(true);
	};

	const onFinishFailed = (errorInfo) => {};
	return (
		<AddDomainPresentational
			domainListLoading={domainListLoading}
			domains={domains}
			modalVisible={modalVisible}
			onFinish={onFinish}
			onFinishFailed={onFinishFailed}
			layout={layout}
			tailLayout={tailLayout}
			handleModalVisible={handleModalVisible}
			removeDomain={removeDomain}
			activeDomain={activeDomain}
			handleEditDomain={handleEditDomain}
			onEditFinish={onEditFinish}
		/>
	);
};

export default AddDomainFunctional;
